/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 13:53:53
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:15:19
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import { API, API_URL } from '@/config';
import { togglePendingStoreActions, handleErrorResponses } from '@/utils/decorators';

import {
  SET_BILLING_TERMS, COMPLETE_BILLING_LIST,
} from './mutation-types';

export default {
  setBillingTerms({ commit, state }, newTerms = {}) {
    const terms = { ...state.billingList.terms, ...newTerms };
    commit(SET_BILLING_TERMS, { terms });
    return Promise.resolve();
  },

  @togglePendingStoreActions()
  @handleErrorResponses()
  async getBillingList({ commit, state }) {
    const { dateStart, dateEnd, sort, sortBy, page } = state.billingList.terms;
    const number = state.billingList.terms.phoneNumber || 'null';
    const params = {
      from: dateStart,
      to: dateEnd,
      sortby: sortBy,
      sort,
      number,
      page,
    };
    const { list, count, summary } = (await API.get(`${API_URL}/billing`, { params })).data.data;
    commit(COMPLETE_BILLING_LIST, { list, count, summary });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Billing/actions.js